import { combineReducers } from 'redux'
import app from './app'
import appAuth from "./app_auth";

export const appReducer = combineReducers({
  app, appAuth
})
